var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("bxzu1h4", "导入历史"),
      "mask-closable": false,
      "width": "900",
      "footer-hide": "",
      "class-name": "member-export-history"
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.visible ? _c('ProTable', _vm._b({
    ref: "proTable"
  }, 'ProTable', _vm.config, false)) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };